import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Item, TimelineType } from '@/types/item';
import { TimelineModal } from '@/types/modal';
import { ErrorModal, NoFooterModal } from '@/components/molecules/common/Modal';
import Timeline from '@/external/timeline/product-timeline';
import { State } from '@/external/timeline/type';
import { useClientId } from '@/hooks/client';
import { Client } from '@/types/client';

const View: React.FC<{ modal: TimelineModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose, type, sellerId = 0 } = modal;

  const [seller, setSeller] = useState<Client>();

  const sellerData = useClientId(sellerId, !!sellerId);

  useEffect(() => {
    if (sellerData.kind === 'Loaded') {
      setSeller(sellerData.data[0]);
    }
  }, [sellerData]);

  try {
    return (
      <NoFooterModal
        title={type === TimelineType.SELLER ? t('modal.timeline.title_seller') : t('modal.timeline.title_buyer')}
        onClose={onClose}
        body={
          <Body
            type={type}
            item={item}
            seller={seller}
          />
        }
        containerStyle={{ minWidth: 400, maxWidth: 800, width: '70%' }}
        modalName="timeline"
      />
    );
  } catch (error) {
    return (
      <ErrorModal
        title={type === TimelineType.SELLER ? t('modal.timeline.title_seller') : t('modal.timeline.title_buyer')}
        message={t('service_error.general')}
        onClose={onClose}
        containerStyle={{ minWidth: 400 }}
      />
    );
  }
};

const Body: React.FC<{ type: TimelineType; item: Item; seller?: Client }> = ({ type, item, seller }) => {
  const [state, updateState] = useState<State>({
    currentTab: type === TimelineType.BUYER ? 'Order' : 'Sale',
    shippingProduct: null,
    currentOrder:
      type === TimelineType.BUYER && item.orderId
        ? { orderId: item.orderId, orderConfirmationDate: '', orderTotalPrice: '' }
        : null,
    currentProduct: {
      ...item,
      productId: String(item.productId),
      productName: item.productName || '',
      ezlink: item.previewLink || '',
      isDirectShipping: item.shippingMethod === 'direct shipping',
      orderConfirmationDate: '',
      productPrice: item.price,
      externalRef: '',
    },
    sellerShippingAddress: item.sellerShippingAddress,
  });

  return (
    <Timeline
      state={{ ...state, seller }}
      updateState={updateState}
    />
  );
};

export default View;
